import React, {
  InputHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { IconBaseProps } from 'react-icons';
import { FiAlertCircle } from 'react-icons/fi';
import { useField, FormHandles } from '@unform/core';
import { Container } from './styles';
import { Error } from '../styles';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { uuid } from 'uuidv4';

interface IListInput {
  label: string;
  name: string;
  value?: string;
}

interface IInputProps {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  setCallback?: Function;
  formRef?: React.RefObject<FormHandles>;
  list?: Array<IListInput>;
  placeholder: string;
  mandatory?: string;
}

const ArrayInputIncluder: React.FC<IInputProps> = ({
  name,
  icon: Icon,
  formRef,
  setCallback = () => { },
  list,
  placeholder,
  mandatory = 'no',
  ...rest
}): JSX.Element => {
  const { fieldName, defaultValue, error, registerField } = useField(name);


  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocus, setIsFocus] = useState(false);
  const [isFilled, setIsFilled] = useState(!!defaultValue);




  const [value, setNewValue] = useState(['']);

  useEffect(() => {

    if (defaultValue?.length > 0) {
      setNewValue(defaultValue)
    }

  }, [defaultValue])

  const handleInputBlur = useCallback(() => {
    setIsFocus(false);
    setIsFilled(!!inputRef.current?.value);
  }, []);

  const handleInputFocus = useCallback(() => {
    setIsFocus(true);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: undefined,
      getValue: (ref: any) => {
        return JSON.parse(ref.value);
      },
      setValue: (ref: any, valueN: string) => {
        setNewValue(valueN ? JSON.parse(valueN) : ['']);
      },
    });
  }, [fieldName, registerField]);

  const addInput = () => {
    const newHash = `q${new Date().getMilliseconds()}`;
    setNewValue([...value, '']);
  }

  const removeItem = (index) => {

    const items: Array<string> = [];

    value.map((v, i) => {
      if (i !== index) {
        items.push(v);
      }
    })

    setNewValue([...items]);



  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <aside style={{ color: '#333', display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}><p style={{ color: '#333' }}>{placeholder} {mandatory === 'yes' ? <label style={{ color: 'red', fontSize: '10px', marginLeft: '5px' }}>*Obrigatório</label> : <></>}</p>

        <button type="button" className="buttonBigGreen" style={{ borderRadius: '10px', width: '100px', height: 'auto', margin: '0px', marginLeft: '5px', padding: '10px', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={addInput}>
          <FaPlus /> Adicionar
        </button>
      </aside>

      <input
        ref={inputRef}
        style={{ display: 'none' }}
        name={name}
        value={JSON.stringify(value)}
      />


      {
        value && value.map((v, index) => {

          const vname = uuid();

          return (
            <Container
              key={vname}
              {...rest}
              isErrored={!!error}
              isFilled={isFilled}
              isFocused={isFocus}
            >

              <input
                placeholder={'Preencher'}
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
                defaultValue={v}
                onChange={e => {
                  const newValue = [...value];


                  newValue[index] = e.target.value;



                  setNewValue([...newValue]);
                }
                }
                name={vname}
              />
              <FaTrash onClick={() => removeItem(index)} size={20} />
              {error && (
                <Error title={error}>
                  <FiAlertCircle />
                </Error>
              )}
            </Container>
          );
        })
      }

    </div >
  );
};

export default ArrayInputIncluder;
